export default __webpack_public_path__ + "static/Jar_of_Pitch-f13dd5c37543909618999a57e18d13b3.jpg";